import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

export default function BasicImage({ data }) {
    const { imageBackgroundColor, imageImageLink, imageImage } = data
    return (
        <section className='mycomponent-1'>
            <div className={`image-center-wrap ${imageBackgroundColor}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='image-center-sec'>
                                {imageImageLink ? (
                                    <a href={imageImageLink}>
                                        <GatsbyImage image={getImage(imageImage.localFile)} alt='image' />
                                    </a>
                                ) : (
                                    <GatsbyImage image={getImage(imageImage.localFile)} alt='image' />
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
